<div class="row" *ngIf="datacenters">
  <div class="col p-0">
    <ng-container *ngIf="isFreemium">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
    <ng-container *ngIf="!isFreemium">
      <app-pie-chart [data]="pieChartData" [height]="'500px'"></app-pie-chart>
      <div class="bg-white px-4">
        <app-data-table-component [data]="datacenters" [headers]="headers"></app-data-table-component>
      </div>
    </ng-container>
  </div>
</div>
